import React from 'react';

const DataEnvironmentNotSet: React.FC = () => {
  return <>{'Data Environment Not Set'}</>;
};

export default DataEnvironmentNotSet;
